module.exports = __webpack_public_path__ + "img/OT663.ac02900.webp";